/* global connect React Component */
import mixinsFunc from "./mixins";
export class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.profileInfo = {
      disabled: {
        "user_name": true,
        "user_id": true,
        "email_address": true,
        "age": true
      }
    }
    let mixins = mixinsFunc(this);
    props.initialconstruct.bind(this)("ProfilePage");
    this.state = {
      infoData:{},
      links: mixins.links || [],
      fields: {
        profileInfo: mixins.profileInfo,
      },
    };
  }
  breadCumRight() {
    return <AppStepper index={1} count={5}></AppStepper>;
  }

  getPersonalData() {
    return new Promise((resolve,reject)=>{
      if(this.props.urlparams.user_id) {
        this.api.execApi('getProfile').then((response) => {
          let data = response.data;
          this.setState((state)=>({
            newrecord:false,
            infoData: data.items[0]
          }),resolve);
        }).catch(reject);
      } else {
        this.api.execApi('getPersonal').then((response) => {
          console.log({response});
          let data = response.data;
          //data.date_of_birth = data.date_of_birth.date().toDateTime();
          this.setState((state)=>({
            newrecord:false,
            infoData: data
          }),resolve);
        }).catch((err)=>{
          this.setState((state)=>({
            newrecord:true,
            infoData:Object.only(this.props.store.user,["user_name","user_id","email_address","contact_number"])
          }));
          console.log({err});
          reject();
        });
      }
    })
  }

  submitRecord(e) {
    let payload = e.target.getData();
    if(this.state.newrecord) {
      payload = Object.except(payload,['user_id']);
      this.api.execApi("postPersonal", payload).then(() => {
        this.getPersonalData().then(v=>{
          navigate("/app/profile/company_info");
        });
      });
    } else {
      payload = Object.except(payload,['user_name','user_id','contact_number','email_address']);
      //payload.gender = enums.genderCode[payload.gender];
      this.api.execApi("putPersonal", payload).then(() => {
        this.getPersonalData().then(v=>{
          navigate("/app/profile/company_info");
        });
      });
    }
    
  }

  componentDidMount() {
    this.getPersonalData();
  }

  render() {
    let { breadCumRight } = this;
    let { links, fields, infoData } = this.state;
    /* eslint-disable-next-line react/jsx-no-undef */
    return (
      <AppWrapper
        customTitle="Update Profile"
        title="Profile"
        slots={{ breadCumRight }}
      >
        <AppLinkTabs data={links}></AppLinkTabs>
        <div className="card">
          <div className="card-body">
            <AppFormData
              fields={fields.profileInfo}
              size={3}
              fieldclass="col-4"
              submitText="Save & Next"
              data={infoData}
              onSubmit={(...arg) => this.submitRecord(...arg)}
              
            />
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default connect(ProfilePage);
